// extracted by mini-css-extract-plugin
module.exports = {"contactsList":"ContactsList_contactsList__1wyTy"};